import { environment } from "../../../environments/environment.development"

const BASE_URL = environment.BASE_URL

export const ROUTES = {
  LOG_IN: `${BASE_URL}/auth/sign-user`,
  LOG_OUT: `${BASE_URL}/auth/logout`,
  AUTH_PERMISSIONS: `${BASE_URL}/auth/permissions`,
  PROFILE_SEARCH: `${BASE_URL}/devotee/profile-search`,
  PROFILE_DETAILS: `${BASE_URL}/devotee/profile`,
  VISITORS_DETAILS: `${BASE_URL}/devotee/visitors`,
  FC_DETAILS: `${BASE_URL}/devotee/fc`,
  USERNAME_AVAILABILITY: `${BASE_URL}/common/username-availability`,
  MEMBER_AVAILABILITY: `${BASE_URL}/common/member-availability`,
  // shared state/district lookups are served by the management backend itself
  // (modules/common — same source the Profile & Identity screens use).
  PINCODE: `${BASE_URL}/common/pincode`,
  STATES: `${BASE_URL}/common/states`,
  BOOKING_DETAILS: `${BASE_URL}/booking/list`,
  BOOKING_ID: `${BASE_URL}/booking/details`,
  VISIT_DETAILS: `${BASE_URL}/booking/visits`,
  SEND_REQ_OTP: `${BASE_URL}/devotee/profile-req`,
  EDIT_NAME: `${BASE_URL}/devotee/name`,
  CONTACT_NUMBERS: `${BASE_URL}/devotee/contact-numbers`,
  AVAILABLE_CONTACT_NUMBERS: `${BASE_URL}/devotee/contact-number-availability`,
  PRIMARY_REQ: `${BASE_URL}/devotee/primary-req`,
  PRIMARY_VERIFY: `${BASE_URL}/devotee/primary-verify`,
  DEVOTEE_ADDRESS: `${BASE_URL}/devotee/address`,
  IMPORT_ADDRESS_BY_DEVOTEE_ID: `${BASE_URL}/devotee/address`,
  UPDATE_DEVOTEE_FC: `${BASE_URL}/devotee/family-code-change-req`,
  VALIDATE_DEVOTEE_FC: `${BASE_URL}/devotee/validate-new-familycode`,
  VALIDATE_NEW_FC: `${BASE_URL}/devotee/new-familycode-status`,
  UPDATE_DEVOTEE_AADHAR: `${BASE_URL}/devotee/aadhaar`,
  UPDATE_VISITOR_AADHAR: `${BASE_URL}/devotee/visitor-aadhaar-req`,
  UPDATE_CONTACT_DEVOTEE: `${BASE_URL}/devotee/contact-number`,
  UPDATE_VISITOR_DETAILS: `${BASE_URL}/devotee/visitor-details`,
  RESOLVE_NAME_AND_MEMBER_CODE: `${BASE_URL}/devotee/resolve-name-and-member-code`,
  RESOLVE_AADHAR_CONFLICT_AND_INACTIVATE: `${BASE_URL}/devotee/resolve-adhar-conflict-and-inactivate`,
  ASSIGN_NEW_CONTACT: `${BASE_URL}/devotee/assign-new-contact`,
  MANUAL_STATUS_UPDATE: `${BASE_URL}/devotee/manual-status-update`,
  ALL_FAMILY_CODE_CHANGE_REQ: `${BASE_URL}/devotee/all-family-code-change-req`,
  OCCUPANCY_STATS: `${BASE_URL}/booking/occupancy-stats`,

  // Establishment (branch) — bookings + check-in/out
  ESTAB_BOOKINGS: `${BASE_URL}/establishment/bookings`,
  ESTAB_MANUAL_BOOKING: `${BASE_URL}/establishment/manual-booking`,
  ESTAB_CHECKIN_CHECKOUT_LISTS: `${BASE_URL}/establishment/checkin-checkout/lists`,
  ESTAB_PROPERTIES: `${BASE_URL}/establishment/properties`,
  ESTAB_ROOMS: `${BASE_URL}/establishment/rooms`,
  ESTAB_UTSAVS: `${BASE_URL}/establishment/utsavs`,
  ESTAB_REPORTS_OCCUPANCY: `${BASE_URL}/establishment/reports/occupancy`,
  ESTAB_REPORTS_SUMMARY: `${BASE_URL}/establishment/reports/summary`,
  ESTAB_REPORTS_UTILIZATION: `${BASE_URL}/establishment/reports/utilization`,
  ESTAB_REPORTS_NO_SHOWS: `${BASE_URL}/establishment/reports/no-shows`,
  ESTAB_REPORTS_TIMELINE: `${BASE_URL}/establishment/reports/occupancy-timeline`,
  ESTAB_REPORTS_MOVEMENTS: `${BASE_URL}/establishment/reports/movements`,
  ESTAB_REPORTS_DEMAND_SUPPLY: `${BASE_URL}/establishment/reports/demand-supply`,
  ESTAB_REPORTS_CANCELLATIONS: `${BASE_URL}/establishment/reports/cancellations`,
  ESTAB_REPORTS_VELOCITY: `${BASE_URL}/establishment/reports/booking-velocity`,
  ESTAB_REPORTS_GUESTS: `${BASE_URL}/establishment/reports/guest-composition`,
  ESTAB_REPORTS_FRONTDESK: `${BASE_URL}/establishment/reports/frontdesk-activity`,
  ESTAB_MANDIR: `${BASE_URL}/establishment/mandir`,
  ESTAB_STAFF: `${BASE_URL}/establishment/staff`,
  ESTAB_UTSAV_IMAGE: `${BASE_URL}/establishment/utsavs/image`,

  // Check-in / Check-out Operator (front desk)
  FD_PREMISES: `${BASE_URL}/frontdesk/premises`,
  FD_DASHBOARD_COUNTS: `${BASE_URL}/frontdesk/dashboard/counts`,
  FD_CHECKIN_LIST: `${BASE_URL}/frontdesk/checkin-desk/list`,
  FD_CHECKOUT_LIST: `${BASE_URL}/frontdesk/checkout-desk/list`,
  FD_CHECKIN: `${BASE_URL}/frontdesk/checkin`,
  FD_CHECKOUT: `${BASE_URL}/frontdesk/checkout`,
  FD_GUEST_HISTORY: `${BASE_URL}/frontdesk/guest-history`,
  FD_MY_ACTIVITY: `${BASE_URL}/frontdesk/my-activity`,
  FD_PROFILE: `${BASE_URL}/frontdesk/profile`,
  FD_PROFILE_MOBILE_OTP: `${BASE_URL}/frontdesk/profile/mobile/request-otp`,
  FD_PROFILE_MOBILE_VERIFY: `${BASE_URL}/frontdesk/profile/mobile/verify-otp`,
  FD_PROFILE_EMAIL: `${BASE_URL}/frontdesk/profile/email`,
  FD_BOOKING: `${BASE_URL}/frontdesk/booking`,
  PROV_REQUISITION: `${BASE_URL}/provisioning/requisition`,
  PROV_DASHBOARD_COUNTS: `${BASE_URL}/provisioning/dashboard/counts`,
  PROV_QUEUE: `${BASE_URL}/provisioning/requisition/by-queue`,
  PROV_LOCK_OLDEST: `${BASE_URL}/provisioning/queue/lock-oldest`,
  PROV_QUEUE_COUNTS: `${BASE_URL}/provisioning/queue/counts`,
  PROV_REQ_BULK_ROLLBACK_ALL: `${BASE_URL}/provisioning/queue/rollback/bulk-all`,
  PROV_REPORT_CONFIRMED: `${BASE_URL}/provisioning/reports/confirmed-bookings`,
  PROV_REPORT_ALLOCATIONS: `${BASE_URL}/provisioning/reports/allocations`,
  PROV_CANCEL_REASONS: `${BASE_URL}/provisioning/cancel-reasons`,
  PROV_MANUAL_PREMISES: `${BASE_URL}/provisioning/manual/premises`,
  PROV_MANUAL_SETS: `${BASE_URL}/provisioning/manual/accommodation-sets`,
  PROV_MANUAL_ROOMS: `${BASE_URL}/provisioning/manual/rooms`,
  PROV_MANUAL_PROVISION: `${BASE_URL}/provisioning/manual/provision`,
  PROV_DEVOTEE: `${BASE_URL}/provisioning/devotee`,
  PROV_BY_DISTRICT: `${BASE_URL}/provisioning/requisition/by-district`,

  // Operator Admin
  OA_BLOCK_DAY: `${BASE_URL}/operator-admin/accommodation/block-day`,
  OA_UNBLOCK_DAY: `${BASE_URL}/operator-admin/accommodation/unblock-day`,
  OA_BLOCKED_DAYS: `${BASE_URL}/operator-admin/accommodation/blocked-days`,
  OA_OPERATORS: `${BASE_URL}/operator-admin/operators`,
  OA_VIEW_PERMISSIONS: `${BASE_URL}/operator-admin/view-permissions`,
  OA_UTSAV: `${BASE_URL}/operator-admin/utsav`,
  OA_UTSAV_IMAGE: `${BASE_URL}/operator-admin/utsav/image`,
  OA_REQUISITION: `${BASE_URL}/operator-admin/requisition`,
  OA_REQ_PENDING: `${BASE_URL}/operator-admin/requisition/pending`,
  OA_REQ_CONFIRMED_CANCEL: `${BASE_URL}/operator-admin/requisition/confirmed-to-cancel`,
  OA_REQ_BULK_ROLLBACK: `${BASE_URL}/operator-admin/requisition/rollback/bulk-all`,
  OA_ASSIGNABLE_ROLES: `${BASE_URL}/operator-admin/assignable-roles`,
  OA_ACTIVITY: `${BASE_URL}/operator-admin/activity`,

  // Central room catalogue (organisation -> premises -> guest house -> room)
  CC_ORGANISATIONS: `${BASE_URL}/central-catalogue/organisations`,
  CC_PREMISES: `${BASE_URL}/central-catalogue/premises`,
  CC_SETS: `${BASE_URL}/central-catalogue/sets`,
  CC_ACCOMMODATIONS: `${BASE_URL}/central-catalogue/accommodations`,
  CC_INSTANCES: `${BASE_URL}/central-catalogue/instances`,
  CC_STATUS_REASONS: `${BASE_URL}/central-catalogue/status-reasons`,

  // Media library (Configurations > Media) + picker options
  MEDIA: `${BASE_URL}/media`, // item routes: /:mediaId, /:mediaId/status
  MEDIA_LIBRARY: `${BASE_URL}/media/library`, // list + upload
  MEDIA_OPTIONS: `${BASE_URL}/media/options`,

  // Platform-wide reports (view platform_reports)
  PLATFORM_REPORTS: `${BASE_URL}/platform-reports`,

  // Realtime (SSE stream)
  REALTIME_EVENTS: `${BASE_URL}/realtime/events`,

  // Super Admin
  SA_USERS: `${BASE_URL}/super-admin/users`,
  SA_ROLES: `${BASE_URL}/super-admin/roles`,
  SA_ESTABLISHMENTS: `${BASE_URL}/super-admin/establishments`,
  SA_VIEWS: `${BASE_URL}/super-admin/views`,
  SA_PERMISSIONS: `${BASE_URL}/super-admin/permissions`,
  SA_VIEW_PERMISSIONS: `${BASE_URL}/super-admin/view-permissions`,
  SA_VIEW_AS_ROLE: `${BASE_URL}/super-admin/view-as-role`,
};
